var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createWorkletRuntime = createWorkletRuntime;
var _initializers = require("./initializers");
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _shareables = require("./shareables");
var _worklet_8129574858859_init_data = {
    code: "function anonymous(){const{setupCallGuard,setupConsole,initializer}=this.__closure;var _initializer;setupCallGuard();setupConsole();(_initializer=initializer)===null||_initializer===void 0?void 0:_initializer();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/runtimes.ts",
    sourceMap: '{"version":3,"names":["anonymous","setupCallGuard","setupConsole","initializer","__closure","_initializer"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/runtimes.ts"],"mappings":"AAgBgC,SAAAA,SAAMA,CAAA,QAAAC,cAAA,CAAAC,YAAA,CAAAC,WAAA,OAAAC,SAAA,KAAAC,YAAA,CAEhCJ,cAAc,CAAC,CAAC,CAChBC,YAAY,CAAC,CAAC,CACd,CAAAG,YAAA,CAAAF,WAAW,UAAAE,YAAA,iBAAXA,YAAA,CAAc,CAAC,CACjB"}',
    version: "3.5.4"
};
function createWorkletRuntime(name, initializer) {
    return _NativeReanimated.default.createWorkletRuntime(name, (0, _shareables.makeShareableCloneRecursive)(function() {
        var _e = [
            new global.Error(),
            -4,
            -27
        ];
        var anonymous = function anonymous() {
            (0, _initializers.setupCallGuard)();
            (0, _initializers.setupConsole)();
            initializer == null ? void 0 : initializer();
        };
        anonymous.__closure = {
            setupCallGuard: _initializers.setupCallGuard,
            setupConsole: _initializers.setupConsole,
            initializer: initializer
        };
        anonymous.__initData = _worklet_8129574858859_init_data;
        anonymous.__workletHash = 8129574858859;
        anonymous.__stackDetails = _e;
        return anonymous;
    }()));
}
